<template>
  <div v-if="hide">
    <h3>应急照明列表</h3>
    <!-- 表格 -->
    <div class="table" style="margin-top: 60px;">
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column type="index" label="序号" header-align="center" align="center" width="100px"> </el-table-column>
        <el-table-column label="回路数" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.deviceNo == null ? "暂无数据" : scope.row.deviceNo }}
          </template>
        </el-table-column>
        <el-table-column prop="position" label="区域" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-show="!flag[scope.$index]" :key="isbutton">
              <span>{{ scope.row.position == null ? "暂无数据" : scope.row.position || "暂无数据" }}</span>
              <i style="margin-left: 20px;cursor: pointer;" @click="edit(scope.$index, scope.row.id, scope.row)" class="el-icon-edit-outline"></i>
            </div>
            <el-input style="width: 300px;" v-show="flag[scope.$index]" @blur="sure(scope.$index, scope.row.id, scope.row)" v-model="scope.row.position" ref="inpVal"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="状态" header-align="center" align="center" prop="state">
          <!-- <template slot-scope="scope" v-if="scope.row.state == null">
           暂无数据
          </template> -->
          <template slot-scope="scope">
            <div v-if="scope.row.state == null">暂无数据</div>
            <div v-else>
              <img class="door1" src="@/assets/img/open_door.png" alt="" v-if="scope.row.state == 1" />
              <img class="door2" src="@/assets/img/close_door.png" alt="" v-else />
              <span class="door_font">{{ scope.row.state == 1 ? "开" : "关" }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next,sizes,total"
        :current-page.sync="query.pageNum"
        @size-change="getList"
        @current-change="getList"
        :page-sizes="[10, 20]"
        :page-size.sync="query.pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getlight } from "../../api/facility";
import config from "../../utils/config.js";
export default {
  props: ["cpNum"],
  data() {
    return {
      tableData: [], // 列表数
      // show: false, // 点击修改按钮
      flag: [], // 让修改按钮隐藏
      query: { pageNum: 1, pageSize: 5 },
      total: 0,
      hide: false,
      isbutton: 0,
      websock: null, // 实时推送数据
    };
  },
  watch: {
    cpNum() {
      this.getList();
    },
  },
  created() {
    this.initWebSocket(); // 进入组件/路由创建一个 webscoket 的实例
  },
  mounted() {
    // 有数据请求接口
    if (this.cpNum) this.getList();
  },
  destroyed() {
    this.websock.close(); //离开组件/路由之后断开 websocket 连接
  },

  methods: {
    edit(index, id, row) {
      // this.$nextTick(() => {
      //   this.$refs.inpVal[index].focus();
      // });
      log(index, id, row, this.flag);
      this.isbutton++;
      this.flag[index] = true;
    },
    sure(index, id, row) {
      var obj = { deviceNo: row.deviceNo, id: id, position: row.position, type: row.type };
      this.$put(`/device/monitorDevice/editPosition`, obj).then((res) => {
        if (res.code == 200) {
          this.$message({message: res.msg,type: "success", duration: 700,});
        }
        if (res.status == 200) {
          this.$message.error(res);
        }
      });
      this.isbutton++;
      this.flag[index] = false;
    },
    // 数据请求
    getList() {
      var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "93fe79c642aa44e182aa3c793dfc9b55" : this.cpNum;
      getlight({ companyNum: cNum, ...this.query }).then((res) => {
        // log(res);
        if (res.rows.length) {
          this.tableData = res.rows;
          this.total = res.total;
          this.hide = true;
        } else {
          this.hide = false;
          this.$message.warning("该业务尚且开通，清联系管理员");
          return;
        }
      });
    },

    initWebSocket() {
      let wsUrl = "";
      if (process.env.NODE_ENV == "development") {
        //本地
        wsUrl = config.wsUrltest;
      } else if (process.env.NODE_ENV == "production") {
        //线上
        wsUrl = config.wsUrl;
      }
      //初始化weosocket
      // const wsuri = "ws://47.105.170.47:8888/ws/mqt";
      // const wsuri = "ws://192.168.0.49:8899/ws/trweb";
      this.websock = new WebSocket(wsUrl);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      log("链接");
      //连接建立之后执行send方法发送数据
      let message = "fasong";
      this.websocketsend(JSON.stringify(message));
    },
    websocketonerror() {
      //连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) {
      //数据接收
      const redata = JSON.parse(e.data);
      for (const iterator of redata) {
        if (iterator.type == "270" && iterator.wsType == 1)
          for (const item of this.tableData) {
            if (item.deviceNo == iterator.deviceNo) {
              item = Object.assign(item, iterator);
            }
          }
      }
    },
    websocketsend(Data) {
      //数据发送
      this.websock.send(Data);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-edit-outline {
  font-size: 18px;
  font-weight: bold;
}
.door_font {
  margin-left: 10px;
  line-height: 4;
}
.door1 {
  width: 60px;
  height: 60px;
}
.door2 {
  width: 60px;
  height: 60px;
}
</style>
